import React, { useState } from 'react'
import { X, Edit2, Trash2 } from 'lucide-react'
import './TaxInvoiceModal.scoped.scss'
import { apiClient } from '../../../api'
import { token } from '../../../config'
import { notification, Spin } from 'antd'
import ModalWarning from '../../../components/Ants/Modal/ModalWarning'

const TaxInvoiceModal = ({ isOpen, onClose, openAddNew, taxInfoList, setTaxInfoId, getTaxInfo, taxIsSelected, setTaxIsSelected, setTaxInfoData, taxInfoData }) => {
  const [openModal, setOpenModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [taxInfoIdIsDelete, setTaxInfoIdIsDelete] = useState(null)

  if (!isOpen) return null

  const handleAddNew = () => {
    setTaxInfoId(null)
    onClose()
    openAddNew()
  }

  const handleEdit = (id) => {
    setTaxInfoId(id)
    onClose()
    openAddNew()
  }

  const handleConfirm = async () => {
    const taxDefault = taxInfoList.find(row => row.id === taxIsSelected)
    setTaxInfoData(taxDefault)
    onClose()

    // const newList = taxInfoList.map((row) => {
    //   if (row.id === taxIsSelected) {
    //     return {
    //       ...row,
    //       isDefault: true,
    //     }
    //   } else {
    //     return {
    //       ...row,
    //       isDefault: false,
    //     }
    //   }
    // })

    // const newTaxInfoList = newList
    //   .filter((row) => row.isDefault)
    //   .map((row) => ({
    //     id: row.id,
    //     isDefault: row.isDefault
    //   }));

    // setTaxIsSelected(newTaxInfoList[0].id)

    // const req = {
    //   "id": newTaxInfoList[0].id,
    //   "isDefault": newTaxInfoList[0].isDefault
    // }

    // await apiClient.post("/api/ecom/update-taxinfo-default", req, {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //     "Content-type": "application/json; charset=UTF-8",
    //   },
    // }).then(res => {
    //   if (res.data.status === 200) {
    //     notification.success({
    //       message: 'Success',
    //       description: 'Successfully update tax invoice information',
    //     })
    //   }
    //   else {
    //     notification.error({
    //       message: 'Error',
    //       description: 'Error update tax invoice information',
    //     })
    //   }
    //   getTaxInfo()
    //   onClose()
    // })
    //   .catch(error => {
    //     console.log(error)
    //     notification.error({
    //       message: 'Error',
    //       description: 'Error update tax invoice information',
    //     })
    //   })
  }

  const handleDelete = async () => {
    setOpenModal(false)
    setLoading(true)
    const req = {
      "target": taxInfoIdIsDelete
    }
    await apiClient.post("/api/ecom/deleteTaxinfo", req, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    }).then(res => {
      if (res.data.status === 200) {
        notification.success({
          message: 'Success',
          description: 'Successfully delete tax invoice information',
        })
      }
      else {
        notification.error({
          message: 'Error',
          description: 'Error delete tax invoice information',
        })
      }
      getTaxInfo()
      onClose()
    })
      .catch(error => {
        console.log(error)
        notification.error({
          message: 'Error',
          description: 'Error delete tax invoice information',
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleDeleteConfirm = async (id) => {
    setTaxInfoIdIsDelete(id)
    setOpenModal(true)
  }

  const handleDefault = (type, id) => {
    setTaxIsSelected(id)
  }

  const handleClose = () => {
    onClose()

    const check = taxInfoData?.id === taxIsSelected
    if (check) {
      setTaxInfoData(taxInfoData)
    } else {
      setTaxIsSelected(taxInfoData?.id)
    }
  }

  return (
    <div className="modal-overlay">
      <div className='modal-container'>
        <Spin spinning={loading}>
          <div className='modal-container-wrapper'>
            <div className='modal-header'>
              <h2 className="modal-title">Tax invoice information</h2>
            </div>
            <div className="tax-modal-content">
              <div className='close-button-wrapper'>
                <button className="close-button" onClick={() => handleClose()}>
                  <X size={20} />
                </button>
              </div>

              <div className="invoice-options">
                {taxInfoList.map((row) => (
                  <div key={row.id} className="option-item">
                    <div className="option-deatils">
                      <label className="radio-container">
                        <input
                          type="radio"
                          name="invoiceType"
                          value={row.type}
                          checked={taxIsSelected ? taxIsSelected === row.id : row.isDefault}
                          onChange={() => handleDefault(row.type, row.id)}
                        />
                        <span className="radio-checkmark"></span>
                        <span className={`option-label`}>
                          {row.type === 1 ? 'Individual' : 'Corporate'}
                        </span>
                      </label>
                      <div className="option-details">
                        <div className="company-name">{row.name}</div>
                        <div className="detail-line">ID Card : {row.id_card}</div>
                        <div className="detail-line">
                          {row.address}{" "}
                          {row.proinve === "กรุงเทพมหานคร" ? "แขวง" : "ตำบล"}{" "}{row.district}{" "}
                          {row.proinve === "กรุงเทพมหานคร" ? "เขต" : "อำเภอ"}{" "}{row.subdistrict}{" "}
                          {row.proinve}{" "}{row.post}
                        </div>
                        <div className="detail-line">{row.mobile}</div>
                      </div>
                    </div>
                    <div className="action-buttons">
                      <Edit2 size={24} color='#19164F' className="action-edit" onClick={() => handleEdit(row.id)} />
                      <Trash2 size={24} color='#19164F' className="action-delete" onClick={() => handleDeleteConfirm(row.id)} />
                    </div>
                  </div>
                ))}
              </div>

              <div className="modal-actions">
                <button className="btn btn-outline" onClick={handleAddNew}>Add new</button>
                <button className="btn btn-primary" onClick={handleConfirm}>Confirm</button>
              </div>
            </div>
          </div>
        </Spin>
      </div>

      <ModalWarning
        loading={loading}
        warningModalVisible={openModal}
        warningModal={() => setOpenModal(false)}
        successModal={() => handleDelete()}
        modalcountDown={() => setOpenModal(false)}
        message={"Are you sure you want to delete this tax invoice?"}
        messageSuccess={""}
      />
    </div>
  )
}

export default TaxInvoiceModal
